/**
 * 분석 대시보드 로딩 중 표시 — props 없음, 자체 완결.
 * Phase 1-1 작은 컴포넌트 추출 (SampleAnalysisPage 분할 1단계).
 */
export default function AnalysisLoadingState() {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
        <p className="text-gray-600 text-sm">분석 데이터를 불러오는 중...</p>
      </div>
    </div>
  );
}
